import * as z from 'zod';
export const Port = (defaultValue) => z.coerce.number('A valid port must be provided.').default(defaultValue);
export const Host = (defaultValue) => z.string().default(defaultValue);
export const Bool = (defaultValue = false) => z
    .enum(['true', 'false'])
    .transform(str => str === 'true')
    .default(defaultValue);
export const Url = (defaultUrl) => z.url().default(defaultUrl);
export function defineEnvironment(env) {
    return env($);
}
function $(key, schema) {
    const result = schema.safeParse(process.env[key]);
    if (!result.success) {
        throw new Error(`Environment variable ${key} is invalid: ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=env-builder.js.map